import { createSelector } from 'reselect';

const selectLogisticsSettings = (state: any) => state.logisticsSettings;


export const selectLogisticsSettingsCurrentItem = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.current);

export const selectLogisticsSettingsListItems = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.list);

export const selectLogisticsSettingsItemById = (itemId: any) =>
    createSelector(selectLogisticsSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectLogisticsSettingsQueryItems = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.query);

export const selectLogisticsSettingsCreatedItem = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.create);

export const selectLogisticsSettingsUpdatedItem = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.update);

export const selectLogisticsSettingsReadItem = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.read);

export const selectLogisticsSettingsDeletedItem = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.delete);

export const selectLogisticsSettingsSearchedItems = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.search);

export const selectLogisticsSettingsItemsCount = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.count);

export const selectLogisticsSettingsItemsFilter = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.filter);

export const selectLogisticsSettingsSummaryItems = createSelector([selectLogisticsSettings], (logisticsSettings) => logisticsSettings.summary);